import React from 'react';
import { makeStyles } from '@material-ui/core';
import UserAPI from '../../api/User';
import { map } from 'lodash';
import AsyncSelect from 'react-select/async';
import PropTypes from 'prop-types';
import clsx from 'clsx';

const useStyles = makeStyles(theme => ({
  root: {
    width: '100%',
    flexShrink: 1,
    height: 'fit-content',
    zIndex: 3
  }
}));

function UserFilter(props) {
  const classes = useStyles();

  /**
   * @description Asynchronously searches for an user
   * @param {string} search - User to search for %rough%
   * @returns {object} - Array of { label: user.name, value: user._id }
   */
  async function loadUser(search) {
    const response = await UserAPI.getAll({
      verified: true,
      sortBy: 'name',
      sortDir: 'asc',
      search
    }).catch(props.onError);

    return map(response.users.rows, r => ({
      value: r._id,
      label: r.name
    }));
  }

  return (
    <AsyncSelect
      aria-label="User Filter"
      className={clsx({
        [classes.root]: !props.className,
        [props.className]: props.className
      })}
      isMulti={props.isMulti}
      cacheOptions
      blurOnInputSelect={false}
      closeMenuOnSelect={true}
      isClearable={props.isClearable}
      placeholder={props.placeholder}
      loadOptions={loadUser}
      onChange={props.onChange}
      menuPlacement="auto"
      styles={props.styles ?? undefined}
      components={props.components ?? undefined}
      value={props.value ?? undefined}
      menuPortalTarget={document.body}
      menuPosition={'fixed'}
    />
  );
}

UserFilter.propTypes = {
  onChange: PropTypes.func.isRequired,
  onError: PropTypes.func,
  className: PropTypes.string,
  isMulti: PropTypes.bool,
  styles: PropTypes.object,
  components: PropTypes.object,
  placeholder: PropTypes.string,
  isClearable: PropTypes.bool,
  value: PropTypes.object
};

UserFilter.defaultProps = {
  onError: console.error,
  isMulti: false,
  placeholder: 'User',
  isClearable: true
};

export default UserFilter;
